import React, { useMemo } from 'react';
import { TextField } from '@mui/material';
import { ACTION_LOG_SUMMARY_MODAL_STATUS, TRANSLATIONS } from 'types/enums';
import './MeetingForSummaryModalStyle.scss';
import { useGetRoutineAvailableInfoQuery } from 'generated/graphql';
import { generateMeetingList } from 'features/action-logs/RoutinesListing/routinesListHelper';
import { Routine } from 'features/action-logs/RoutinesListing/RoutinesListing';
import { useTranslation } from 'react-i18next';
import Autocomplete from '@mui/lab/Autocomplete';

type MeetingForSummaryModalProps = {
  modalStatus: ACTION_LOG_SUMMARY_MODAL_STATUS;
  meeting: Routine;
  handleMeetingChange: (meeting: Routine) => void;
};
function MeetingForSummaryModal(props: MeetingForSummaryModalProps) {
  const { t } = useTranslation();
  const { data } = useGetRoutineAvailableInfoQuery(
    {
      variables: { forFilter: false },
    },
  );
  const meetingsList = generateMeetingList(data?.getRoutinesAvailable as any);
  const meetingsListHash = useMemo(() => {
    const hash: any = {};
    meetingsList.forEach(meetingsListItem => {
      if (!hash[meetingsListItem.value]) {
        hash[meetingsListItem.value] = meetingsListItem.label;
      }
    });
    return hash;
  }, [meetingsList]);
  const { modalStatus, meeting, handleMeetingChange } = props;
  function onChange(e: Routine) {
    handleMeetingChange({
      label: meetingsListHash[e?.value] || '' as any,
      value: e?.value || '' as any,
    });
  }

  return modalStatus === ACTION_LOG_SUMMARY_MODAL_STATUS.SUMMARY ? (
    <div className="check">
      <p className="extra_title">{t(TRANSLATIONS.REVIEW_IN)}</p>
      <p className="extra_sub_title">{meeting.label}</p>
    </div>
  ) : (
    <div className="check selection_dropdown">
      <p className="extra_title">{t(TRANSLATIONS.REVIEW_IN)}</p>
      <Autocomplete
        key="meeting_select"
        options={meetingsList || []}
        isOptionEqualToValue={(option: any, value: any) => option?.id === value?.id}
        value={meetingsList?.length ? meetingsList
          ?.find(e => String(e?.value) === String(meeting?.value as any))
          : () => null}
        getOptionLabel={(option: any) => option?.label}
        style={{ minWidth: 164 }}
        renderInput={params => (
          <TextField
            {...params}
            variant="outlined"
            inputProps={{
              ...params.inputProps,
              style: {
                padding: 0,
              },
            }}
          />
        )}
        disableClearable
        onChange={(event, value: any) => {
          onChange(value);
        }}
      />
    </div>
  );
}
export default MeetingForSummaryModal;
